export default "__VITE_ASSET__DDQVeASd__"